/**
 * Drops `accountId` from a location search string, keeping every other query param as-is.
 *
 * `?accountId=` outranks the current selection in `resolveActiveAccountId`, so switching artists
 * from the switcher must clear it from the URL — otherwise the next render's resolver reads the
 * stale id and switches straight back.
 */
export function removeAccountIdFromSearch(search: string): string {
  if (!search.includes('accountId')) {
    return search;
  }
  const params = new URLSearchParams(search);
  if (!params.has('accountId')) {
    return search;
  }
  params.delete('accountId');
  const next = params.toString();
  return next === '' ? '' : `?${next}`;
}
